import { useMediaQuery } from '@material-ui/core'
import { ExpandMore, Sort } from '@material-ui/icons'
import * as React from 'react'
import styled from 'styled-components'
import { animated, useSpring, config } from 'react-spring'
import { VideoSelectedFilter } from '../TrendingVideos'

const StyledTableHeader = styled.thead`
  position: relative;
  background: none;
  color: #aaa;

  th:first-child {
    padding-left: 15px;
    padding-right: 0;
  }

  th:last-child {
    padding-left: 0px;
    padding-right: 15px;
  }

  th {
    text-align: left;
    font-size: 14px;
    font-weight: 700;

    @media (max-width: 43em) {
      font-size: 12px;
    }
  }
`

const Filter = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  white-space: nowrap;
  gap: 5px;
  cursor: pointer;
  color: ${(props) => (props.selected ? 'white' : '#aaa')};

  :hover {
    color: white;
  }
`

const DropdownFilter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  color: white;
`

const Menu = styled(animated.div)<{ visible: boolean }>`
  position: absolute;
  z-index: 100;
  /* top: calc(100% + 10px); */
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-width: 1px;
  border-color: #333;
  border-style: solid;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 15px 25px rgba(255, 255, 255, 0.052);
  pointer-events: ${(props) => (props.visible ? 'all' : 'none')};

  right: 15px;

  :focus,
  *:focus {
    outline: none;
  }
`

const PopoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
`

const MenuItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: calc(100% - 20px);
  padding: 15px 10px;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;

  :hover {
    background: #232323;
  }
`

const MenuItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const MenuItemTitle = styled.div<{ color: string }>`
  font-weight: 700;
  color: ${(props) => props.color};
  font-size: 14px;
  text-align: right;
  width: 100%;

  @media (max-width: 43em) {
    font-size: 12px;
  }
`

interface Props {
  selected: VideoSelectedFilter
  setSelected: (filter: VideoSelectedFilter) => void
}

const VideoHeader = ({ selected, setSelected }: Props): JSX.Element => {
  const isTablet = useMediaQuery('(max-width: 62em)')
  const [visible, setVisible] = React.useState(false)
  const [opened, setOpened] = React.useState(false)

  const menuOpenState = useSpring({
    opacity: visible ? 1 : 0,
    config: config.gentle,
    onRest: () => {
      setOpened(visible)
    },
  })

  const toggleHide = (): void => {
    if (opened) {
      setVisible(false)
      const element = document.getElementById('filter-menu')
      element?.blur()
    } else {
      setVisible(true)
    }
  }

  if (isTablet) {
    return (
      <StyledTableHeader id="filter-menu" tabIndex={0} onBlur={() => setVisible(false)}>
        <tr>
          <th>RANK</th>
          <th>
            <DropdownFilter onClick={toggleHide}>
              {selected === VideoSelectedFilter.PRIMARY
                ? 'PRIMARIES'
                : selected === VideoSelectedFilter.SECONDARY
                ? 'SECONDARIES'
                : 'TOTAL'}
              <ExpandMore />
            </DropdownFilter>
            <Menu visible={visible} style={menuOpenState}>
              <PopoverWrapper>
                <MenuItem onClick={() => setSelected(VideoSelectedFilter.PRIMARY)}>
                  <MenuItemLeft>
                    <MenuItemTitle color="white">PRIMARY SALES</MenuItemTitle>
                  </MenuItemLeft>
                </MenuItem>
                <MenuItem onClick={() => setSelected(VideoSelectedFilter.SECONDARY)}>
                  <MenuItemLeft>
                    <MenuItemTitle color="white">SECONDARY SALES</MenuItemTitle>
                  </MenuItemLeft>
                </MenuItem>
                <MenuItem onClick={() => setSelected(VideoSelectedFilter.TOTAL)}>
                  <MenuItemLeft>
                    <MenuItemTitle color="white">TOTAL VOLUME</MenuItemTitle>
                  </MenuItemLeft>
                </MenuItem>
              </PopoverWrapper>
            </Menu>
          </th>
        </tr>
      </StyledTableHeader>
    )
  }

  return (
    <StyledTableHeader>
      <tr>
        <th>RANK</th>
        <th>
          <Filter
            selected={selected === VideoSelectedFilter.PRIMARY}
            onClick={() => setSelected(VideoSelectedFilter.PRIMARY)}
          >
            {`PRIMARY SALES`}
            {selected === VideoSelectedFilter.PRIMARY && <Sort />}
          </Filter>
        </th>
        <th>
          <Filter
            selected={selected === VideoSelectedFilter.SECONDARY}
            onClick={() => setSelected(VideoSelectedFilter.SECONDARY)}
          >
            {`SECONDARY SALES`}
            {selected === VideoSelectedFilter.SECONDARY && <Sort />}
          </Filter>
        </th>
        <th>
          <Filter
            selected={selected === VideoSelectedFilter.TOTAL}
            onClick={() => setSelected(VideoSelectedFilter.TOTAL)}
          >
            {`TOTAL VOLUME`}
            {selected === VideoSelectedFilter.TOTAL && <Sort />}
          </Filter>
        </th>
      </tr>
    </StyledTableHeader>
  )
}

export default VideoHeader
